import { router as InertiaRouter } from '@inertiajs/vue3'

export default {
  methods: {
    $route (name, args, absolute, config) {
      return route(name, args, absolute, config)
    },
    $goRoute (name, args, absolute, config) {
      InertiaRouter.visit(this.$route(name, args, absolute, config))
    },
    $goUrl (url) {
      InertiaRouter.visit(url)
    },
    $leaveUrl (url) {
      window.location.href = url
    },
  },
}
